import { Button, TextArea } from "@synthesis/shared-ui";
import { cn } from "@synthesis/shared-utils";
import { FormProvider, useForm } from "react-hook-form";

import type { CommentFormValues } from "../../application-detail-page.lib";
import { UserAvatar } from "../user-avatar";

type CommentFormProps = {
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  onSubmit?: (formData: CommentFormValues) => void | Promise<void>;
};

export const CommentForm = ({ placeholder = "Напишите комментарий", className, disabled = false, onSubmit }: CommentFormProps) => {
  const methods = useForm<CommentFormValues>({
    defaultValues: { comment: "" },
    mode: "onSubmit",
  });

  const comment = methods.watch("comment");
  const isSubmitDisabled = disabled || !comment.trim();

  const handleSubmit = methods.handleSubmit(async (formData) => {
    await onSubmit?.(formData);
    methods.reset();
  });

  return (
    <div className={cn("flex gap-3", className)}>
      <UserAvatar currentUser />

      <div className="relative w-full">
        <form onSubmit={handleSubmit}>
          <FormProvider {...methods}>
            <TextArea rows={4} placeholder={placeholder} name="comment" disabled={disabled} />
            <Button type="submit" className="absolute bottom-3 right-3" size="md" theme="primary" disabled={isSubmitDisabled}>
              Отправить
            </Button>
          </FormProvider>
        </form>
      </div>
    </div>
  );
};
